import { useCallback } from 'react';
import { useApp } from '../../context/AppContext';
import logger from '../../utils/logger';

/**
 * Hook para manejo centralizado de errores
 * 
 * @returns {Function} handleError - Función para manejar errores
 * 
 * @example
 * const handleError = useErrorHandler();
 * 
 * try {
 *   await someAsyncOperation();
 * } catch (error) {
 *   handleError(error, 'Error al realizar la operación');
 * }
 */
export const useErrorHandler = () => {
    const { notify } = useApp();

    const handleError = useCallback((error, customMessage = null) => {
        // Log del error
        logger.error('Error manejado:', error);

        // Extraer mensaje del error
        let errorMessage = customMessage;

        if (!errorMessage) {
            // Intentar obtener mensaje del error de la API
            if (error?.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error?.response?.data?.error) {
                errorMessage = error.response.data.error;
            } else if (error?.message) {
                errorMessage = error.message;
            } else {
                errorMessage = 'Ha ocurrido un error inesperado. Por favor, intenta nuevamente.';
            }
        }

        // Mostrar notificación al usuario
        notify({
            title: 'Error',
            type: 'error',
            text: errorMessage,
            time: 5000 // 5 segundos
        });

        // Retornar el error para que el componente pueda manejarlo si es necesario
        return error;
    }, [notify]);

    return handleError;
};

export default useErrorHandler;

